module.exports = __webpack_public_path__ + "img/CorDx.acedf8c7.webp";